export const hourlyBreakdownConstant = [
	{time: "00:00:00", order: 0},
	{time: "01:00:00", order: 1},
	{time: "02:00:00", order: 2},
	{time: "03:00:00", order: 3},
	{time: "04:00:00", order: 4},
	{time: "05:00:00", order: 5},
	{time: "06:00:00", order: 6},
	{time: "07:00:00", order: 7},
	{time: "08:00:00", order: 8},
	{time: "09:00:00", order: 9},
	{time: "10:00:00", order: 10},
	{time: "11:00:00", order: 11},
	{time: "12:00:00", order: 12},
	{time: "13:00:00", order: 13},
	{time: "14:00:00", order: 14},
	{time: "15:00:00", order: 15},
	{time: "16:00:00", order: 16},
	{time: "17:00:00", order: 17},
	{time: "18:00:00", order: 18},
	{time: "19:00:00", order: 19},
	{time: "20:00:00", order: 20},
	{time: "21:00:00", order: 21},
	{time: "22:00:00", order: 22},
	{time: "23:00:00", order: 23},
]

export const dailyBreakdown = [
	{day: "SUNDAY", order: 0},
	{day: "MONDAY", order: 1},
	{day: "TUESDAY", order: 2},
	{day: "WEDNESDAY", order: 3},
	{day: "THURSDAY", order: 4},
	{day: "FRIDAY", order: 5},
	{day: "SATURDAY", order: 6},
]

export const timezonesWithOffSet = [
	{zone: "UTC", offset: 0},
	{zone: "US/Alaska", offset: 9},
	{zone: "US/Central", offset: 6},
	{zone: "US/Eastern", offset: 5},
	{zone: "US/Hawaii", offset: 10},
	{zone: "US/Mountain", offset: 7},
	{zone: "US/Pacific", offset: 8}
];